import { createTheme, ThemeOptions } from "@mui/material"
import themeComponents from "./theme-components"

const colors = {
  primaryMain: "#F9FAFB",
  primaryContrastText: "#171717",
  secondaryMain: "#1E293B",
  secondaryContrastText: "#ffffff",
  errorMain: "#FA897B",
  successMain: "#D0E6A5",
  warningMain: "#FFDD94",
  infoMain: "#A8D8F0",
  textPrimary: "#fff",
  textSecondary: "#D1D5DB",
  textDisabled: "#6B7280",
  divider: "#232323",
  backgroundDefault: "#ffffff",
  sidebarMain: "#334155",
  actionHover: "#E2E8F0",
  actionSelected: "#232323",
  tableFontSize: "0.875rem",
  borderColor: "#232323",
  loadingDot: "#ffffff",
  tableHeaderBgColor: "#232323",
  inputBoxBgColor: "#1E293B",
  inputLabelColor: "#F9FAFB",
  inputPlaceHolderColor: "#999999"
}

const darkTheme: ThemeOptions = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: colors.primaryMain,
      contrastText: colors.primaryContrastText
    },
    secondary: {
      main: colors.secondaryMain,
      contrastText: colors.secondaryContrastText
    },
    error: {
      main: colors.errorMain
    },
    success: {
      main: colors.successMain,
      contrastText: colors.primaryContrastText
    },
    info: {
      main: colors.infoMain,
      contrastText: colors.primaryContrastText
    },
    warning: {
      main: colors.warningMain
    },
    background: {
      default: "#171717",
      paper: "#090e1a"
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled
    },
    divider: colors.divider,
    action: {
      hover: colors.divider,
      selected: "#4B5563"
    },
    neutral: {
      main: "#A1A1AA",
      contrastText: colors.backgroundDefault
    },
    sidebar: {
      main: colors.sidebarMain,
      contrastText: "#F1F5F9",
      hover: colors.sidebarMain,
      submenuBackground: colors.secondaryMain,
      active: colors.sidebarMain
    },
    grey: {
      500: colors.textDisabled
    },
    table: {
      headerColor: colors.primaryMain,
      headerBackground: colors.tableHeaderBgColor,
      color: colors.primaryMain,
      background: colors.sidebarMain,
      active: colors.actionSelected,
      border: colors.borderColor,
      fontSize: "0.875rem"
    },
    scrollbar: {
      thumb: colors.actionSelected,
      track: colors.sidebarMain
    },
    input: {
      boxBgColor: colors.inputBoxBgColor,
      labelColor: colors.inputLabelColor,
      placeholderColor: colors.inputPlaceHolderColor
    } as any
  },

  typography: {
    fontFamily: `'Poppins',"Lato", "Inter",Roboto, sans-serif`,
    h1: { fontSize: "1.54rem", fontWeight: 700, lineHeight: 1.5 },
    h2: { fontSize: "1.32rem", fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: "1.1rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.01rem", fontWeight: 600, lineHeight: 1.3 },
    h5: { fontSize: "0.88rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "0.88rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.77rem", fontWeight: 400, lineHeight: 1.4 },
    subtitle1: { fontSize: "0.66rem", fontWeight: 400, lineHeight: 1.3 },
    subtitle2: { fontSize: "0.55rem", fontWeight: 400, lineHeight: 1.2 },
    caption: { fontSize: "0.55rem", fontWeight: 400, lineHeight: 1.1 }
  },

  components: themeComponents
})

export default darkTheme
